export default __webpack_public_path__ + "media/images/images_v2/onglettitre-liste-cfcd61ea97572041fa8e177ff0b417cc.png";